module.exports = __webpack_public_path__ + "static/assets/11a1abb455c81cc58f23c2181ab027ab.png";